import data from "./pflegedaten.json";
export function getData(count, type) {
  const index = count % data[type].length;
  const returnString = data[type][index];
  return type === "images" && !returnString.startsWith("http")
    ? `/images/pflegeheim/${returnString}`
    : returnString;
}
